import { TabPanel, TabPanelProps } from '@inmarket/inmarkit';

const TabPanelDiv = (props: TabPanelProps) => (
  <TabPanel
    {...props}
    typographyProps={{ variant: 'body2', variantMapping: { body2: 'div' } }}
  />
);

export default TabPanelDiv;
